export default __webpack_public_path__ + "static/media/b2.c949f748.svg";